import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, makeStyles, IconButton } from '@material-ui/core';
import Logo from '../Images/Logo.webp';
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch } from 'react-redux';
import { userNotLoggedIn } from '../DataStore/Slices/userSlice'

const useSyles = makeStyles(theme => ({
    dialogWrapper: {
        padding: theme.spacing(2),
        position: 'absolute',
        top: 'initial'
    }
}));

function Popup(props) {
    const { title, children, openPopup, setOpenPopup, popupSize } = props;
    const classes = useSyles();
    const dispatch = useDispatch();

    const closePopup = () => {
        setOpenPopup(false);
        if (title === 'Login') {
            dispatch(userNotLoggedIn());
        }
    };

    useEffect(() => {
        // document.body.style.overflow = 'hidden';
        return () => document.body.style.overflow = 'scroll';
     }, []);


    return (
        <Dialog open={openPopup} classes={{ paper: classes.dialogWrapper }} maxWidth={popupSize ? popupSize : 'xs'}
            fullWidth={true}>
            <DialogTitle>
                <div className="popup__header">
                    <div className="popup__Logo">
                        {/* <img className="img-fluid" src={Logo} alt="Website Logo" width="200px" />&nbsp; */}
                        <span className="text-start navbar-brand-text">{title}</span>
                    </div>
                    <div className="popup__closeIcon">
                        <IconButton color="secondary" aria-label="close popup" onClick={closePopup}>
                            <CancelIcon />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    )
};

export default Popup;

